import {
  DELETE_VIDEO_URL,
  GET_ALL_VIDEOS,
  UPDATE_VIDEO_URL,
  UPLOAD_VIDEO_URL,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

const getAuthToken = () => {
  return Cookies.get("institution_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getAllVideos = async (course = "", batch = "") => {
  const params = new URLSearchParams();
  if (course) params.append("course", course);
  if (batch) params.append("batch", batch);
  
  const url = params.toString() ? `${GET_ALL_VIDEOS}?${params.toString()}` : GET_ALL_VIDEOS;
  
  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const uploadVideos = async (payload) => {
  const isFormData = payload instanceof FormData;

  const response = await fetch(UPLOAD_VIDEO_URL, {
    method: "POST",
    headers: {
      ...getHeadersWithoutContentType(),
      ...(!isFormData && { "Content-Type": "application/json" }),
    },
    body: isFormData ? payload : JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const updateVideos = async (payload, id) => {
  const isFormData = payload instanceof FormData;
  const response = await fetch(`${UPDATE_VIDEO_URL}?id=${id}`, {
    method: "PUT",
    headers: {
      ...getHeadersWithoutContentType(),
      ...(!isFormData && { "Content-Type": "application/json" }),
    },
    body: isFormData ? payload : JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
export const deleteVideos = async (id) => {
  if (!id) throw new Error("Video id is required for delete");
  const params = new URLSearchParams();
  params.append("id", id);
  const response = await fetch(`${DELETE_VIDEO_URL}?${params.toString()}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

const getHeadersWithoutContentType = () => {
  const token = getAuthToken();
  if (token) {
    return { Authorization: ` ${token}` };
  }
  return {};
};
